import { render, staticRenderFns } from "./Crisis_Reporting_file.vue?vue&type=template&id=f9cc5f5a"
import script from "./Crisis_Reporting_file.vue?vue&type=script&lang=js"
export * from "./Crisis_Reporting_file.vue?vue&type=script&lang=js"
import style0 from "./Crisis_Reporting_file.vue?vue&type=style&index=0&id=f9cc5f5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports